interface UseStaggerOptions {
  distance?: number;
  duration?: number;
  pageSize?: number;
}

export function useStaggerTransition(options: UseStaggerOptions = {}) {
  const distance = options.distance ?? 8;
  const duration = options.duration ?? 250;
  const pageSize = options.pageSize ?? 20;

  const beforeEnter = (el: HTMLElement) => {
    el.style.opacity = '0';
    el.style.transform = `translateY(${distance}px)`;
    el.style.transition = `all ${duration}ms ease`;
  };

  const enter = (el: HTMLElement, done: () => void) => {
    const delay = (Number(el.dataset.index) % pageSize) * 30;

    setTimeout(() => {
      el.style.transition = `all ${duration}ms ease`;
      el.style.removeProperty('opacity');
      el.style.removeProperty('transform');
      done();
    }, delay);
  };

  const leave = (el: HTMLElement, done: () => void) => {
    el.style.transition = `all ${duration}ms ease`;
    el.style.opacity = '0';
    el.style.transform = `translateY(-${distance}px)`;
    setTimeout(() => {
      el.style.removeProperty('transition');
      done();
    }, duration);
  };

  return { beforeEnter, enter, leave };
}
